<template>
  <div class="Login-Container">
    <img :src="splashUrl" alt="" class="splashImg" />
    <div class="login-form">
      <div class="top-right-icons">
        <div class="top-right-button" data-cy="header.language">
          <language-dropdown />
        </div>
      </div>
      <form @submit.prevent="signInUser" v-on:keyup.enter="signInUser">
        <img src="@/assets/logo.png" class="logo" />
        <h1>{{ $t('auth.login.register') }}</h1>

        <vv-form-text-input
          :testId="$cypress.anonymous.login.username"
          label="username"
          id="username"
          v-model="username"
          :validate="'required|email'"
          type="email"
          class="username"
        />

        <vv-form-text-input
          :testId="$cypress.anonymous.login.password"
          label="password"
          id="password"
          type="password"
          v-model="password"
          :validate="'required'"
        />

        <span class="ForgotPassword-Text" @click="$router.push('reset-password')">
          {{ $t('forms.forgotPasswordCta') }}
        </span>

        <validate-form-button
          v-cypress="$cypress.anonymous.login.button"
          @click="signInUser"
          :isLoading="isLoading"
          :label="'forms.loginCta'"
          class="validateLogin"
        />

        <span class="Register-Text">{{ $t('auth.login.registerIntro') }}</span>

        <validate-form-button
          v-cypress="$cypress.anonymous.login.new_account"
          @click="$router.push('PreRegister')"
          :isLoading="false"
          :full="false"
          :label="'auth.login.registerCta'"
        />
        <span class="Register-Text alcool-warning">{{ $t('auth.login.alcoolWarning') }}</span>
      </form>
    </div>
  </div>
</template>

<script>
import ValidateFormButton from '@/components/common/ValidateFormButton'
import { SET_FORM_USER_INFORMATIONS } from '@/store/modules/user/types'
import VvFormTextInput from '@/components/common/forms/VvFormTextInput'
import { splash_screen_url } from '@/lib/remote-config/constants'
import remoteConfig from '@/lib/remote-config'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'
import userMixin from '@/mixins/user'
import LanguageDropdown from '@/components/language/LanguageDropdown'

export default {
  name: 'Login',
  components: {
    VvFormTextInput,
    ValidateFormButton,
    LanguageDropdown
  },
  mixins: [userMixin],
  data: () => ({
    username: '',
    password: '',
    isLoading: false,
    error: '',
    redirect: null,
    splashUrl: ''
  }),
  methods: {
    async signInUser() {
      this.error = ''

      if (this.username === '' || this.password === '') {
        this.$eventBus.$emit(SNACKBAR_MESSAGE, {
          message: this.$t('errors.custom/missing-credentials')
        })
        return
      }

      this.isLoading = true

      try {
        await this.login(this.username, this.password)
      } catch (error) {
        this.isLoading = false
      }

      // let isLoading to true until app.vue catchup the firebase user
      // and set the user logged in store
    }
  },
  mounted() {
    this.splashUrl = remoteConfig.getString(splash_screen_url)
    this.$store.commit(SET_FORM_USER_INFORMATIONS, { name: 'paul', test: 'cc' })
    if (this.isUserLogged) {
      return this.$router.push({ name: 'home' })
    }
    this.redirect =
      this.$route.query && this.$route.query.redirect ? this.$route.query.redirect : null
  },
  watch: {
    '$store.state.user.userLogged': function(userLogged) {
      if (userLogged) {
        if (this.redirect) this.$router.push({ path: this.redirect })
        else this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';
.top-right-icons {
  align-self: flex-end;
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Helvetica', sans-serif;
  max-width: 80000px;
  background-color: white;
  border-radius: 13px;
  position: absolute;
  top: 25px;
  .top-right-button {
    width: 40px;
    height: 30px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
  h1 {
    width: 70%;
    text-align: center;
    letter-spacing: 0px;
    font-weight: 400;
    font-size: 2rem;
    color: #404040;
    opacity: 1;
  }
}

.Login-Container {
  width: 100vw;
  height: 100vh;
  font-family: 'DM Sans', sans-serif;
}
.login-form {
  float: right;
  margin-right: 10%;
  margin-top: 8%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 500px;
  height: 600px;
  padding: 50px;
  background: #f8f6ef 0% 0% no-repeat padding-box;
  border-radius: 45px;
  background-color: rgba(248, 246, 239, 0.67);
}

.splashImg {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0px;
  left: 0px;
  object-fit: cover;
  z-index: -1;
}

// .FormText {
//   height: 32px;
//   border-radius: 5px;
//   background-color: #f6f6f6;
//   display: block;
//   padding-bottom: 8px;
//   width: 70%;
//   margin-bottom: 14px;
// }

// .validateLogin:hover {
//   background-color: aqua;
// }
.logo {
  width: 300px;
  //margin-bottom: 40px;
}

.FormContainer {
  display: block;
}

.FormLabel {
  display: block;
  width: 10em;
  height: 16px;
  text-align: left;
  margin-bottom: 8px;
}

.ForgotPassword-Text {
  display: block;
  height: 14px;
  font-family: $font-family-splash;
  font-size: 10.5px;
  font-weight: 500;
  // color: $font-color-light;
  color: #404040;
  text-decoration: underline;
  margin-bottom: 20px;
  margin-top: 15px;
  cursor: pointer;
}

.alcool-warning {
  font-size: 0.8rem;
  width: 80%;
  text-align: center;
}

.Register-Text {
  display: block;
  margin-top: 16px;
  margin-bottom: 14px;
  // color: $font-color-light;
  color: #404040;
}

.username {
  margin-bottom: 6px;
}

@media (max-width: 1024px) {
  
  .login-form {
    margin-right: 10%;
    margin-top: 18%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
      position: relative;
    width: 450px;
    height: 600px;
    background: #f8f6ef 0% 0% no-repeat padding-box;
    border-radius: 45px;
    background-color: rgba(248, 246, 239, 0.67);
  }
}

@media (max-width: 620px) {
  .Login-Container {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    font-family: 'DM Sans', sans-serif;
  }
  .login-form {
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
      position: relative;
    width: 250px;
    height: 550px;
    padding: 50px;
    background: #f8f6ef 0% 0% no-repeat padding-box;
    border-radius: 45px;
    background-color: rgba(248, 246, 239, 0.67);
  }
}
</style>
